import React from 'react';
import {Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {langService} from "../../../jwt/_services";
import LangTab from "../../../components/tabs/langTab";
import {langRoutService} from "../../../jwt/_services/relations/langRoutService";
import {showLoader} from "../../../components/loader/loader";


class RoutLang extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rout: this.props.rout,
            langChilds: [],
            langRoutChilds: [],

            loading: false,
            editMode: this.props.editMode,
            disableInputs: this.props.disableInputs
        }

        this.setForm = this.setForm.bind(this);
        this.onNameChange = this.onNameChange.bind(this);

        this.getLangChilds = this.getLangChilds.bind(this);
        this.getFormulary = this.getFormulary.bind(this);
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
        // ----------------------------------
        // Establece las opciones de idioma
        // ----------------------------------
        let langChilds = [];
        langService.getAll()
            .then(langOptions => {
                if (langOptions) {
                    langOptions.map((lang, index) => {
                        const langChild = {
                            lang: lang,
                            name: '',
                            id: '',
                        };
                        langChilds.push(langChild);
                        this.setState({
                            langChilds,
                            loading: false
                        });
                    });
                } else {
                    this.setState({loading: false});
                }
            })
            .then(() => {
                // ----------------------------------
                // Consulta los idiomas guardados
                // ----------------------------------
                if (this.state.editMode) {
                    langRoutService.search({id: this.state.rout?.id})
                        .then((langRoutChilds) => {
                            this.setState({langRoutChilds});
                        })
                        .then(() => {
                            if (this.state.langRoutChilds && this.state.langRoutChilds.length > 0) {
                                langChilds = this.combineLangChilds(this.state.langChilds, this.state.langRoutChilds);
                                this.setState({
                                    langChilds,
                                    loading: false
                                });
                            } else {
                                this.setState({loading: false});
                            }
                        })
                }
            })
            .catch(() => {
                this.setState({
                    loading: false
                });
            });
    }

    setForm(editMode, showList, data) {
        this.props.setForm(editMode, showList, data)
    }

    getLangChilds() {
        const langChilds = this.combineLangChilds(this.state.langChilds, this.state.langRoutChilds);
        return (langChilds ? langChilds : (this.state?.langChilds ? this.state?.langChilds : []));
    }

    changeDisabledInput(option){
        this.setState({disableInputs : option });
        this.getLangChilds(); // Refresh component
    }

    combineLangChilds(langOptions, langRoutChilds) {
        try {
            if (langOptions && langRoutChilds && langOptions.length > 0 && langRoutChilds.length > 0) {
                langOptions.map((child, index) => {
                    const langRoutIndex = langRoutChilds.findIndex(n => n.lang.id === child.lang.id);

                    if (langRoutIndex !== -1) {
                        // significa que si lo encontro
                        langOptions[index] = {
                            lang: langRoutChilds[langRoutIndex].lang,
                            name: langRoutChilds[langRoutIndex].name,
                            colorName: langRoutChilds[langRoutIndex].colorName,
                            id: langRoutChilds[langRoutIndex].id
                        }
                    }
                });
                return langOptions;
            }
        } catch (e) {
            return e.message;
        }
    }

    onNameChange(value, color, index, lang) {

        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);
        let langChilds = this.state.langChilds.slice();
        if (langIndex === -1)
            return;

        langChilds[langIndex] = {
            lang: langChilds[langIndex].lang,
            name: value,
            colorName: color,
            id: langChilds[langIndex].id
        }

        // Le envia la información al componente padre
        this.props.updateItem(langChilds);

        this.setState({
            langChilds: langChilds,
            langRoutChilds: langChilds
        });
    }

    onColorChange(value, name,  index, lang) {

        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);
        let langChilds = this.state.langChilds.slice();
        if (langIndex === -1)
            return;

        langChilds[langIndex] = {
            lang: langChilds[langIndex].lang,
            name: name,
            colorName: value,
            id: langChilds[langIndex].id
        }

        // Le envia la información al componente padre
        this.props.updateItem(langChilds);

        this.setState({
            langChilds: langChilds,
            langRoutChilds: langChilds
        });
    }

    getFormulary(child, index, disableInputs) {
        return (
            <Form>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label>Nombre</Label>
                            <Input type="name" name="Name"
                                   placeholder="Nombre de la ruta"
                                   value={child.name}
                                   onChange={e => this.onNameChange(e.target.value, child.colorName, index, child.lang)}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label>Color</Label>
                            <Input type="name" name="colorName"
                                   placeholder="Color de la ruta"
                                   value={child.colorName}
                                   onChange={e => this.onColorChange(e.target.value, child.name, index, child.lang)}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        );
    }

    render() {
        return (
            <div>
                {this.state.loading ? showLoader() : null}
                <Row>
                    <Col md="12">
                        <LangTab
                            key={"LangTabId"}
                            langChilds={this.state.langChilds}
                            getLangChilds={this.getLangChilds}
                            getFormulary={this.getFormulary}
                            getDisableInputs={this.getDisableInputs}
                            disableInputs={this.state.disableInputs}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}


export default RoutLang;
